export function getRandomColor() {
  const userColors = [
    "#cf222e", // Red
    "#2da44e", // Green
    "#0969da", // Blue
    "#bf3989", // Pink
    "#ec6547", // Coral
    "#bf8700", // Yellow
    "#bc4c00", // Orange
    "#8250df", // Purple
    "#003d16", // Dark Green
    "#033d8b", // Dark Blue
  ];
  const randomIndex = Math.floor(Math.random() * userColors.length);
  return userColors[randomIndex];
}

export const logMicrositeUpdate = (ydoc, message = "Got microsite update") => {
  const pageIds = ydoc.getArray("pageIds");
  const sectionIds = ydoc.getArray("sectionIds");
  const pageMaps = pageIds.map((id) => ydoc.getMap(id));
  const sectionMaps = sectionIds.map((id) => ydoc.getMap(id));
  const isDirty = ydoc.getMap("editorState").get("isDirty");
  console.log(message, {
    pageIds: pageIds.toJSON(),
    sectionIds: sectionIds.toJSON(),
    pageMaps: pageMaps.map((map) => map.toJSON()),
    sectionMaps: sectionMaps.map((map) => map.toJSON()),
    isDirty,
  });
};

export function decodeBase64ToBinary(update: string) {
  return Uint8Array.from(atob(update), (c) => c.charCodeAt(0));
}
